import moment from 'moment';
import { FRONTEND_DATE_FORMAT } from 'providence-types';
import { DateMoment } from '@models/types';

export const isExcludedValidationDate = (value?: DateMoment): boolean =>
  moment(value).isSame(moment('01/01/1950', FRONTEND_DATE_FORMAT), 'day');
